<div class="row content__grid">
  <div class="col-lg-12 col-md-12 col-sm-12 col-12">
    <div class="page-title-box">
      <div class="row align-items-center">
        <div class="col-sm-6 col-md-6 col-sm-6 col-6">
          <h4 class="page-title content__title">Lista agencias</h4>
        </div>
        <div class="col-sm-6 col-sm-6 col-md-6 col-sm-6 col-6 content__boxBtnHead">
          <ng-container>
            <a routerLink="/{{branchofficeSlug}}/turismo/agencias/nuevo" class="btn btn-primary">
              <i class="fa fa-plus m-r-5"></i> Crear agencia </a>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
  <div class="col-lg-12 col-lg-12 col-md-12 col-sm-12 col-12">
    <div class="card content__grid__card">
      <div class="card-body content__grid__cardbody">
        <div class="content__subhead">
          <div class="row">
            <div class="col-lg-7 col-md-7 col-sm-6 col-12 content__subhead__boxBtns">
              <button type="button" class="btn btn-light btn-sm" title="Actualizar" (click)="refresh()">
                <i class="fas fa-undo"></i></button>
            </div>
            <div class="col-lg-5 col-md-5 col-sm-6 col-12">
              <component-search (searchEvent)="search($event)"></component-search>
            </div>

          </div>
        </div>
        <div class="content__boxTble">
          <div class="table-responsive">
            <table class="table table-hover mb-0">
              <thead class="thead-default">
                <tr>
                  <th>Nombre agencia</th>
                  <th class="hide-xs">N° RUC</th>
                  <th>Celular</th>
                  <th class="hide-xs">Teléfono</th>
                  <th>Encargados</th>
                  <th class="text-center">Acciones</th>
                </tr>
              </thead>
              <tbody>
                <ng-container *ngIf="items.length == 0">
                  <td colspan="2"><span>No se encontraron registros</span></td>
                </ng-container>
                <ng-container *ngIf="items.length > 0">
                  <tr
                    *ngFor="let item of items | paginate: { itemsPerPage: dataPagination.pageSize, currentPage: dataPagination.currentPage, totalItems:dataPagination.totalItems }; let i = index">
                    <td>{{item.tradename}}</td>
                    <td class="hide-xs">{{item.document}}</td>
                    <td>{{item.cellphone}}</td>
                    <td class="hide-xs">{{item.telephone}}</td>
                    <td>
                      <ng-container *ngIf="item.managers_data.length > 0">
                        <div class="btn-group mo-mb-2">
                          <button class="btn btn-light btn-dots btn-sm dropdown-toggle" type="button"
                            data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            <i class="fas fa-clipboard-list m-r-5"></i>
                            <i class="fas fa-ellipsis-h"></i>
                          </button>
                          <div class="dropdown-menu" x-placement="bottom-start">
                            <ul class="p-l-23 p-r-5 m-b-10 p-t-5" style="font-weight: 400;">
                              <li *ngFor="let manager of item.managers_data" style="line-height: 1.2em;" class="nowrap">
                                <span class="f-s-11 m-r-4">{{manager.fullname}}</span>
                                <span class="f-s-10">({{manager.cellphone}})</span>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </ng-container>
                      <ng-container *ngIf="item.managers_data.length == 0">
                        <p class="f-s-10 m-b-0 m-t-0">
                          <i style="font-weight: 300;"
                            class="fas fa-window-minimize"></i></p>
                      </ng-container>
                    </td>
                    <td class="text-center">
                      <a class="btn p-5 pointer text-danger bold" (click)="delete(item, i)">
                        <i class="far fa-trash-alt"></i>
                      </a>
                      <a class="btn p-5 pointer text-success bold" (click)="edit(item.id)">
                        <i class="fas fa-pencil-alt"></i>
                      </a>
                    </td>
                  </tr>
                </ng-container>
              </tbody>
            </table>
          </div>
        </div>
        <div class="col-md-12 ">
          <div class="row content_pagination">
            <div class="col-lg-4">
              <p class="pagination__label">Total <span class="bold">{{dataPagination.totalItems}}</span> registros.</p>
            </div>
            <div class="text-right col-lg-8">
              <ng-container *ngIf="items.length > 0">
                <app-pagination (paginateEvent)="handlePageChange($event)"></app-pagination>
              </ng-container>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
